import { Slide } from "@jelly/lesson";

import dataPreparation from "./components/data-preparation";
import resynthesis from "./components/resynthesis";
import simulation from "./components/simulation";

const principle: Slide = {
  title: "Vehicle Sound Generation",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Data Preparation" }, { name: "Resynthesis" }, { name: "Interactive Simulation" }],
          options: {},
        },
      ],
      components: [dataPreparation, resynthesis, simulation],
      extraContent: [[]],
    },
  },
};

export default principle;
